import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { PermittingHttpService } from '@core/services/http';
import { BROWSE_DEFAULT_FILTER_VALUE } from '@models/constants';
import { JurisdictionActions } from '@store/actions';
import store from '@store/index';

export class JurisdictionBrowseResolver implements Resolver {
  async resolve(): Promise<void> {
    store.dispatch(JurisdictionActions.resetTabsData.done());

    await HttpService.getHttpRequests(
      PermittingHttpService,
    ).getJurisdictionBrowseData(BROWSE_DEFAULT_FILTER_VALUE);
  }
}
